module.exports = __webpack_public_path__ + "static/logo-22a9d4a73e924ca7b436838c9b36b8f9.png";